import cx from "classnames";
import React from "react";
import * as s from "./TrackItem.module.css";
const TrackItem = ({ className, ...props }) => /* @__PURE__ */ React.createElement("li", {
  className: cx(s.trackItemGrid, className),
  ...props
});
const Marker = ({ className, ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: cx(s.trackItemMarker, className),
  ...props
});
const Time = ({ className, ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: cx(s.trackItemTime, className),
  ...props
});
const Info = ({ className, ...props }) => /* @__PURE__ */ React.createElement("div", {
  className: cx(s.trackItemInfo, className),
  ...props
});
TrackItem.Marker = Marker;
TrackItem.Time = Time;
TrackItem.Info = Info;
var TrackItem_default = TrackItem;
export {
  Info,
  Marker,
  Time,
  TrackItem_default as default
};
